import React from 'react'
import { Col, Dropdown, FormGroup, Row, Form } from 'react-bootstrap';

const GiftMenu = ({ giftOptions, selectedCampaignOption, onClick, inline = false }) => {
  if (giftOptions.checkBox) {
    // When checkBox is true, render a checkbox
    // Default to defaultValue (false), checked state uses the other value from optionValues
    const defaultValue = giftOptions.defaultValue;
    const optionValues = giftOptions.optionValues || {};
    
    // Find the other value from optionValues (the one that's not defaultValue)
    let otherValue = null;
    for (const key in optionValues) {
      // Convert string keys to their actual types for comparison
      let keyValue;
      if (key === 'true') {
        keyValue = true;
      } else if (key === 'false') {
        keyValue = false;
      } else {
        keyValue = key;
      }
      
      // Use strict comparison to find the value that's different from defaultValue
      if (keyValue !== defaultValue) {
        otherValue = keyValue;
        break;
      }
    }
    
    // If no otherValue found, default to the opposite boolean if defaultValue is boolean
    if (otherValue === null && typeof defaultValue === 'boolean') {
      otherValue = !defaultValue;
    }
    
    const currentOption = selectedCampaignOption?.option ?? defaultValue;
    const isChecked = currentOption !== defaultValue;
    const handleCheckboxChange = () => {
      // Toggle between defaultValue (unchecked) and otherValue (checked)
      const newOption = isChecked ? defaultValue : otherValue;
      onClick(newOption);
    };

    return (
      <FormGroup>
        <Row className="sm-gutters">
          <Col xs={12}>
            <Form.Check
              id="gift-option-checkbox"
              className="pre-field flex-children"
            >
              <Form.Check.Input
                type='checkbox'
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <Form.Check.Label>
                {giftOptions.title}
              </Form.Check.Label>
            </Form.Check>
          </Col>
        </Row>
      </FormGroup>
    );
  }

  // Default dropdown behavior
  return (
    <FormGroup>
      <Row className="sm-gutters">
        <Col xs={12}>
          <span style={{ lineHeight: '2.5' }}>{ giftOptions.title }&nbsp;</span>
          <Dropdown className={inline ? 'inline-block ml2' : 'mt1'}>
            <Dropdown.Toggle>
              { selectedCampaignOption.optionTitles[selectedCampaignOption.option] || selectedCampaignOption.option }
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {
                giftOptions.options.map(o => (
                  <Dropdown.Item 
                    key={o}
                    active={!!selectedCampaignOption && (selectedCampaignOption.option === o)}
                    onClick={() => onClick(o)}
                  >
                    { selectedCampaignOption.optionTitles[o] || o }
                  </Dropdown.Item>
                ))
              }
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    </FormGroup>
  );
}

export default GiftMenu